'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaDatabase = function FaDatabase(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20.1 17.1q5.3 0 9.9-0.9t7.3-2.9v3.8q0 1.6-2.3 2.9t-6.3 2.1-8.6 0.8-8.6-0.8-6.2-2.1-2.3-2.9v-3.8q2.7 1.9 7.3 2.9t9.8 0.9z m0 17.2q5.3 0 9.9-1t7.3-2.8v3.8q0 1.5-2.3 2.8t-6.3 2.1-8.6 0.8-8.6-0.8-6.2-2.1-2.3-2.8v-3.8q2.7 1.9 7.3 2.8t9.8 1z m0-8.6q5.3 0 9.9-0.9t7.3-2.9v3.8q0 1.6-2.3 2.9t-6.3 2.1-8.6 0.7-8.6-0.7-6.2-2.1-2.3-2.9v-3.8q2.7 1.9 7.3 2.9t9.8 0.9z m0-25.7q4.7 0 8.6 0.8t6.3 2.1 2.3 2.8v2.9q0 1.5-2.3 2.8t-6.3 2.1-8.6 0.8-8.6-0.8-6.2-2.1-2.3-2.8v-2.9q0-1.5 2.3-2.8t6.3-2.1 8.5-0.8z' })
        )
    );
};

exports.default = FaDatabase;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/database.js
// module id = 1202
// module chunks = 0